import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractTypeSapParameterService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ContractTypeSapParameterCreateDto,
  ContractTypeSapParameterDto,
  ContractTypeSapParameterExcelDownloadDto,
  ContractTypeSapParameterUpdateDto,
} from '../proxy/controlling/dtos/contract-type-sap-parameter';
import { CONTRACTTYPESAPPARAMETER_CONFIG, CONTRACTTYPESAPPARAMETER_FIELDS } from './contract-type-sap-parameter.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-contract-type-sap-parameter',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ContractTypeSapParameterService, ConfirmationService],
  templateUrl: './contract-type-sap-parameter.html',
  styleUrl: './contract-type-sap-parameter.scss',
})
export class ContractTypeSapParameter extends BaseHierarchicalCrudComponent<
  ContractTypeSapParameterDto,
  ContractTypeSapParameterCreateDto,
  ContractTypeSapParameterUpdateDto,
  ContractTypeSapParameterExcelDownloadDto
> {
  service = inject(ContractTypeSapParameterService);
  config = CONTRACTTYPESAPPARAMETER_CONFIG;
  fields = CONTRACTTYPESAPPARAMETER_FIELDS;

  protected prepareUpdateDto(data: any, selected: ContractTypeSapParameterDto): ContractTypeSapParameterUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ContractTypeSapParameter';
  }
}
